import type { BoardTeachingTile } from "./board";
import { allowedVideoEmbedUrl } from "./learn";
export type LearningFilter = "all" | "unwatched" | "completed" | "logged";
export function filterSessions(
  tiles: BoardTeachingTile[],
  search: string,
  specialty: string,
  progress: LearningFilter,
  videosOnly: boolean,
) {
  const words = search.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
  return tiles.filter((tile) => {
    const text =
      `${tile.title} ${tile.body} ${tile.specialist.name} ${tile.specialist.practice} ${tile.specialtyName}`.toLocaleLowerCase();
    return (
      words.every((word) => text.includes(word)) &&
      (!specialty || tile.specialtyName === specialty) &&
      (!videosOnly || Boolean(allowedVideoEmbedUrl(tile.videoUrl))) &&
      (progress === "all" ||
        (progress === "unwatched" && !tile.completed) ||
        (progress === "completed" && tile.completed) ||
        (progress === "logged" && tile.cpdLogged))
    );
  });
}
